"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusAccountFileDto = void 0;
class StatusAccountFileDto {
}
exports.StatusAccountFileDto = StatusAccountFileDto;
//# sourceMappingURL=status-account-file.dto.js.map